<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <v-app class="app">
    <notification />
    <Navbar v-if="!this.$route.meta.hideNavBar" />
    <v-content>
      <v-container class="fluid pa-0 ec-app-container">
        <router-view />
      </v-container>
    </v-content>

    <!-- eslint-disable-next-line -->
    <Footer />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer"
import Navbar from "@/components/Navbar"
import Notification from "@/components/Notification"
import axios from "axios"
import qs from "qs"

axios.interceptors.request.use(req => {
  req.paramsSerializer = params =>
    qs.stringify(params, { arrayFormat: "brackets" })
  return req
})

export default {
  name: "App",
  methods: {},
  components: { Navbar, Footer, Notification }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700|Material+Icons");

.app {
  position: relative;
  min-height: 100%;

  // vuetify fix for ie11
  .application--wrap {
    width: 100%;
    .v-content__wrap {
      width: 100%;
    }
  }

  .ec-app-container {
    height: 100%;
  }
}
</style>

<style lang="stylus">
// steps for overriding vuetify styling

// step 1.1: redefine variables from _variables.scss until we figure out how to access sass from stylus
$color-ec-lightest-gray := #e9e9e9;

// step 1.2: override vuetify variables
$body-font-family := "Source Sans Pro", sans-serif;
$font-size-root := 16px;

// step 2.1: import theme before we can override them
@import '~vuetify/src/stylus/settings/_theme'

// step 2.2: override vuetify theme
$material-light.app-bar = $color-ec-lightest-gray;

// step 3: import vuetify style
@import '~vuetify/src/stylus/main';
</style>



// WEBPACK FOOTER //
// src/App.vue